export {
  default as theme
} from 'prism-themes/themes/prism-base16-ateliersulphurpool.light.css';
